import React, { Component } from "react";
import { Button, Popup } from "devextreme-react";
import DataGrid from "devextreme-react/data-grid";

export default class Keywords extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
    };

    this.keywords = [
      { keyword: "%STARTUP_NAME", description: "Startup name" },
      {
        keyword: "%STARTUP_FOUNDER_FIRST_NAME",
        description: "Startup founder first name",
      },
      {
        keyword: "%STARTUP_FOUNDER_LAST_NAME",
        description: "Startup founder last name",
      },
      {
        keyword: "%STARTUP_FOUNDER_EMAIL",
        description: "Startup founder email",
      },
      {
        keyword: "%STARTUP_MOBILE_NUMBER",
        description: "Startup contact number",
      },
      { keyword: "%STARTUP_VALUATION", description: "Startup valuation" },
      { keyword: "%STARTUP_SECTOR", description: "Startup sector" },
      { keyword: "%STARTUP_SEGMENT", description: "Startup sector" },
      { keyword: "%STARTUP_INDUSTRY", description: "Startup industry" },
      { keyword: "%STARTUP_STAGE", description: "Startup stage" },
      { keyword: "%STARTUP_ASK_AMOUNT", description: "Startup ask amount" },
      { keyword: "%STARTUP_CITY", description: "Startup city" },
      {
        keyword: "%STARTUP_BUSINESS_DESCRIPTION",
        description: "Startup description",
      },
      { keyword: "%STARTUP_LEAD_SOURCE", description: "Startup lead source" },
      { keyword: "%INVESTOR_EMAIL", description: "Investor email" },
      { keyword: "%INVESTOR_FIRST_NAME", description: "Investor First Name" },
      { keyword: "%INVESTOR_LAST_NAME", description: "Investor Last Name" },
      {
        keyword: "%INVESTOR_WHOSE_CONTACT",
        description: " Investor contact person",
      },
      {
        keyword: "%INVESTOR_CONTACT_NUMBER",
        description: " Investor contact number",
      },
      { keyword: "%INVESTOR_FUND_NAME", description: "Investor fund name" },
      { keyword: "%INVESTOR_DESIGNATION", description: "Investor designation" },
      { keyword: "%INVESTOR_TYPE", description: "Investor type" },
      // {
      //   keyword: "%BIRTHDAY_INFO",
      //   description: "Create a table of birthday information",
      // },
    ];

    this.togglePopup = () => {
      this.setState({
        visible: !this.state.visible,
      });
    };
  }

  render() {
    return (
      <>
        <Button text="Keywords" onClick={this.togglePopup} />
        <Popup
          title={"Keywords"}
          visible={this.state.visible}
          onHiding={this.togglePopup}
          closeOnOutsideClick={false}
        >
          <DataGrid
            dataSource={this.keywords}
            searchPanel={{ visible: true }}
          ></DataGrid>
        </Popup>
      </>
    );
  }
}
